export class AudioPlayer {
  private voice: SpeechSynthesisVoice | null = null;
  private supported: boolean;

  constructor() {
    this.supported = typeof window !== "undefined" && "speechSynthesis" in window;
    if (!this.supported) return;
    this.pickVoice();
    window.speechSynthesis.onvoiceschanged = () => this.pickVoice();
  }

  private pickVoice(): void {
    const voices = window.speechSynthesis.getVoices();
    this.voice =
      voices.find(v => /hr|croat/i.test(v.lang + v.name)) ||
      voices.find(v => /^sr|serb|bs|sl/i.test(v.lang)) ||
      null;
  }

  speak(text: string): void {
    if (!this.supported) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "hr-HR";
    if (this.voice) u.voice = this.voice;
    u.rate = 0.92;
    window.speechSynthesis.speak(u);
  }

  isSupported(): boolean { return this.supported; }
}
